import {
  HeaderMenuTitle,
  SearchListCard,
} from '@aibees/elephant/feature/search-list-card';
import { Tab } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { TabContext } from '@mui/lab';
import { Box } from '@mui/material';
import { memo, useState } from 'react';
import { RecordManagementHeader } from './components/record-management-header';
import { useRecordCounts } from './hooks/use-record-counts';
import * as Styled from './styles';
import * as SX from './sx';
import type { RecordManagmentPopupProps as Props, RecordType } from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;

export const RecordManagmentPopup = memo(
  ({ className, state, type = 'lists' }: Props) => {
    const [value, setValue] = useState<RecordType>(type);

    const { exportsCount, labelsCount, listsCount, savedCount } =
      useRecordCounts();

    const handleChange = (
      event: React.SyntheticEvent,
      newValue: RecordType
    ) => {
      setValue(newValue);
    };

    return (
      <Styled.Wrapper
        state={state}
        className={classnames('RecordManagmentPopup', className)}
        sx={SX.root}
        contentSx={SX.content}
        anchorOrigin={ANCHOR_ORIGIN}
        transformOrigin={TRANSFORM_ORIGIN}
      >
        <RecordManagementHeader value={value} />

        <TabContext value={value}>
          <Box>
            <Styled.Tabs
              onChange={handleChange}
              color="primary"
              textColor="primary"
              variant="fullWidth"
              size="medium"
            >
              <Tab
                label="Lists"
                value="lists"
                iconPosition="end"
                LabelContent={listsCount}
                LabelVariant="soft"
              />
              <Tab
                label="Labels"
                value="labels"
                iconPosition="end"
                LabelContent={labelsCount}
                LabelVariant="soft"
              />
              <Tab
                label="Saved"
                value="saved"
                iconPosition="end"
                LabelContent={savedCount}
                LabelVariant="soft"
              />
              <Tab
                label="Exports"
                value="exports"
                iconPosition="end"
                LabelContent={exportsCount}
                LabelVariant="soft"
              />
            </Styled.Tabs>
          </Box>

          <Styled.Panel value="lists">
            <SearchListCard title={HeaderMenuTitle.Lists} hasTabs />
          </Styled.Panel>
          <Styled.Panel value="labels">
            <SearchListCard title={HeaderMenuTitle.Labels} hasTabs />
          </Styled.Panel>
          <Styled.Panel value="saved">
            <SearchListCard title={HeaderMenuTitle.Saved} hasTabs />
          </Styled.Panel>
          <Styled.Panel value="exports">
            <SearchListCard title={HeaderMenuTitle.Export} hasTabs />
          </Styled.Panel>
        </TabContext>
      </Styled.Wrapper>
    );
  }
);

RecordManagmentPopup.displayName = 'RecordManagmentPopup';
